import { render, staticRenderFns } from "./VideoInfo.vue?vue&type=template&id=29bd8cae&scoped=true"
import script from "./VideoInfo.vue?vue&type=script&lang=js"
export * from "./VideoInfo.vue?vue&type=script&lang=js"
import style0 from "./VideoInfo.vue?vue&type=style&index=0&id=29bd8cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bd8cae",
  null
  
)

export default component.exports